var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "form-convention-servitude",
      on: { change: _vm.updateConventionsList }
    },
    [
      _c(
        "form",
        { on: { submit: _vm.submitConvention } },
        [
          _c("h3", { staticClass: "offset-2 mt-2" }, [
            _vm._v(
              "Convention de servitudes " +
                _vm._s(_vm.numero) +
                " (" +
                _vm._s(_vm.statut || "Création") +
                ")"
            )
          ]),
          _vm._v(" "),
          _c("hr"),
          _vm._v(" "),
          _c("div", { staticClass: "form-group row" }, [
            _c("div", { staticClass: "col-2 label" }, [
              _vm._v("Type de réseau")
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "col-10" },
              [
                _c("radio-input", {
                  key: "TypeReseau.Elec",
                  attrs: {
                    name: "TypeReseau",
                    value: _vm.TypeReseau.Elec,
                    default: _vm.TypeReseau.Default,
                    label: "Électricité",
                    required: ""
                  },
                  model: {
                    value: _vm.data.TypeReseau,
                    callback: function($$v) {
                      _vm.$set(_vm.data, "TypeReseau", $$v)
                    },
                    expression: "data.TypeReseau"
                  }
                }),
                _vm._v(" "),
                _c("radio-input", {
                  key: "TypeReseau.EclairagePublic",
                  attrs: {
                    name: "TypeReseau",
                    value: _vm.TypeReseau.EclairagePublic,
                    default: _vm.TypeReseau.Default,
                    label: "Éclairage public",
                    required: ""
                  },
                  model: {
                    value: _vm.data.TypeReseau,
                    callback: function($$v) {
                      _vm.$set(_vm.data, "TypeReseau", $$v)
                    },
                    expression: "data.TypeReseau"
                  }
                }),
                _vm._v(" "),
                _c("radio-input", {
                  key: "TypeReseau.InfraCommunicationElectronique",
                  attrs: {
                    name: "TypeReseau",
                    value: _vm.TypeReseau.InfraCommunicationElectronique,
                    default: _vm.TypeReseau.Default,
                    label: "Infrastructures de Communications Électroniques",
                    required: ""
                  },
                  model: {
                    value: _vm.data.TypeReseau,
                    callback: function($$v) {
                      _vm.$set(_vm.data, "TypeReseau", $$v)
                    },
                    expression: "data.TypeReseau"
                  }
                })
              ],
              1
            )
          ]),
          _vm._v(" "),
          _vm.data.TypeReseau === _vm.TypeReseau.Elec
            ? [
                _c("div", { staticClass: "form-group row" }, [
                  _c("div", { staticClass: "col-sm-2 label" }, [
                    _vm._v("Type d'ouvrage")
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "col-10" },
                    [
                      _c("radio-input", {
                        key: "TypeOuvrage.LignesEtCoffretsDistribution",
                        attrs: {
                          name: "TypeOuvrage",
                          value: _vm.TypeOuvrage.LignesEtCoffretsDistribution,
                          default: _vm.TypeOuvrage.Default,
                          label: "Lignes et coffrets de distribution",
                          required: ""
                        },
                        model: {
                          value: _vm.data.TypeOuvrage,
                          callback: function($$v) {
                            _vm.$set(_vm.data, "TypeOuvrage", $$v)
                          },
                          expression: "data.TypeOuvrage"
                        }
                      }),
                      _vm._v(" "),
                      _c("radio-input", {
                        key: "TypeOuvrage.PosteTransfo",
                        attrs: {
                          name: "TypeOuvrage",
                          value: _vm.TypeOuvrage.PosteTransfo,
                          default: _vm.TypeOuvrage.Default,
                          label: "Poste de transformation",
                          required: ""
                        },
                        model: {
                          value: _vm.data.TypeOuvrage,
                          callback: function($$v) {
                            _vm.$set(_vm.data, "TypeOuvrage", $$v)
                          },
                          expression: "data.TypeOuvrage"
                        }
                      }),
                      _vm._v(" "),
                      _c("radio-input", {
                        key: "TypeOuvrage.PosteTransfoEtLigne",
                        attrs: {
                          name: "TypeOuvrage",
                          value: _vm.TypeOuvrage.PosteTransfoEtLigne,
                          default: _vm.TypeOuvrage.Default,
                          label: "Poste de transformation + lignes",
                          required: ""
                        },
                        model: {
                          value: _vm.data.TypeOuvrage,
                          callback: function($$v) {
                            _vm.$set(_vm.data, "TypeOuvrage", $$v)
                          },
                          expression: "data.TypeOuvrage"
                        }
                      }),
                      _vm._v(" "),
                      _c("radio-input", {
                        key: "TypeOuvrage.RepriseBranchement",
                        attrs: {
                          name: "TypeOuvrage",
                          value: _vm.TypeOuvrage.RepriseBranchement,
                          default: _vm.TypeOuvrage.Default,
                          label: "Reprise de branchement",
                          required: ""
                        },
                        model: {
                          value: _vm.data.TypeOuvrage,
                          callback: function($$v) {
                            _vm.$set(_vm.data, "TypeOuvrage", $$v)
                          },
                          expression: "data.TypeOuvrage"
                        }
                      })
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _vm.data.TypeOuvrage ===
                  _vm.TypeOuvrage.LignesEtCoffretsDistribution ||
                _vm.data.TypeOuvrage === _vm.TypeOuvrage.PosteTransfoEtLigne
                  ? [
                      _c("div", { staticClass: "form-group row" }, [
                        _c("div", { staticClass: "col-sm-2 label" }, [
                          _vm._v("Type de ligne")
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "col-10" },
                          [
                            _c("checkbox-input", {
                              key: "Aerien",
                              attrs: { label: "Aérien" },
                              model: {
                                value: _vm.data.Aerien,
                                callback: function($$v) {
                                  _vm.$set(_vm.data, "Aerien", $$v)
                                },
                                expression: "data.Aerien"
                              }
                            }),
                            _vm._v(" "),
                            _c("checkbox-input", {
                              key: "Souterrain",
                              attrs: { label: "Souterrain" },
                              model: {
                                value: _vm.data.Souterrain,
                                callback: function($$v) {
                                  _vm.$set(_vm.data, "Souterrain", $$v)
                                },
                                expression: "data.Souterrain"
                              }
                            })
                          ],
                          1
                        )
                      ]),
                      _vm._v(" "),
                      _vm.data.Aerien
                        ? [
                            _c("h3", { staticClass: "offset-2" }, [
                              _vm._v("Aérien")
                            ]),
                            _vm._v(" "),
                            _c("hr"),
                            _vm._v(" "),
                            _c("div", { staticClass: "form-group row" }, [
                              _vm._m(0),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "col-2" },
                                [
                                  _c("number-input", {
                                    directives: [
                                      { name: "focus", rawName: "v-focus" }
                                    ],
                                    key: "LongueurLigne",
                                    attrs: { min: 0, step: 0.1, required: "" },
                                    model: {
                                      value: _vm.data.LongueurLigne,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.data,
                                          "LongueurLigne",
                                          _vm._n($$v)
                                        )
                                      },
                                      expression: "data.LongueurLigne"
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _vm._m(1),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "col-2" },
                                [
                                  _c("number-input", {
                                    key: "NbSupports",
                                    attrs: { min: 0, required: "" },
                                    model: {
                                      value: _vm.data.NbSupports,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.data,
                                          "NbSupports",
                                          _vm._n($$v)
                                        )
                                      },
                                      expression: "data.NbSupports"
                                    }
                                  })
                                ],
                                1
                              )
                            ]),
                            _vm._v(" "),
                            _vm.data.NbSupports > 0
                              ? _c("div", { staticClass: "form-group row" }, [
                                  _vm._m(2),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "col-10" }, [
                                    _c(
                                      "div",
                                      { staticClass: "row" },
                                      _vm._l(
                                        _vm.data.DimensionsMassifs,
                                        function(massif, i) {
                                          return _c(
                                            "div",
                                            { staticClass: "col-3 mb-2" },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "input-group input-group-sm convention-massif"
                                                },
                                                [
                                                  _c("text-input", {
                                                    key:
                                                      "DimensionsMassifs.Repere." +
                                                      i,
                                                    attrs: {
                                                      "max-length": 3,
                                                      title: "Repère"
                                                    },
                                                    model: {
                                                      value: massif.Repere,
                                                      callback: function($$v) {
                                                        _vm.$set(
                                                          massif,
                                                          "Repere",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "massif.Repere"
                                                    }
                                                  }),
                                                  _vm._v(" "),
                                                  _vm._m(3, true),
                                                  _vm._v(" "),
                                                  _c("number-input", {
                                                    key:
                                                      "DimensionsMassifs.Longueur." +
                                                      i,
                                                    attrs: {
                                                      "no-spinner": "",
                                                      step: 0.1,
                                                      min: 0.1,
                                                      required: ""
                                                    },
                                                    model: {
                                                      value: massif.Longueur,
                                                      callback: function($$v) {
                                                        _vm.$set(
                                                          massif,
                                                          "Longueur",
                                                          _vm._n($$v)
                                                        )
                                                      },
                                                      expression:
                                                        "massif.Longueur"
                                                    }
                                                  }),
                                                  _vm._v(" "),
                                                  _vm._m(4, true),
                                                  _vm._v(" "),
                                                  _c("number-input", {
                                                    key:
                                                      "DimensionsMassifs.Largeur." +
                                                      i,
                                                    attrs: {
                                                      "no-spinner": "",
                                                      step: 0.1,
                                                      min: 0.1,
                                                      required: ""
                                                    },
                                                    model: {
                                                      value: massif.Largeur,
                                                      callback: function($$v) {
                                                        _vm.$set(
                                                          massif,
                                                          "Largeur",
                                                          _vm._n($$v)
                                                        )
                                                      },
                                                      expression:
                                                        "massif.Largeur"
                                                    }
                                                  })
                                                ],
                                                1
                                              )
                                            ]
                                          )
                                        }
                                      ),
                                      0
                                    )
                                  ])
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _c("div", { staticClass: "form-group row" }, [
                              _vm._m(5),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "col-2" },
                                [
                                  _c(
                                    "label",
                                    {
                                      staticClass: "form-label",
                                      attrs: {
                                        for: "NbAncragesDonnantSurParcelle"
                                      }
                                    },
                                    [_vm._v("la parcelle")]
                                  ),
                                  _vm._v(" "),
                                  _c("number-input", {
                                    key: "NbAncragesDonnantSurParcelle",
                                    attrs: {
                                      disabled:
                                        _vm.data
                                          .NbAncragesDonnantSurVoiePublique > 0,
                                      min: 0,
                                      required: ""
                                    },
                                    model: {
                                      value:
                                        _vm.data.NbAncragesDonnantSurParcelle,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.data,
                                          "NbAncragesDonnantSurParcelle",
                                          _vm._n($$v)
                                        )
                                      },
                                      expression:
                                        "data.NbAncragesDonnantSurParcelle"
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "col-2" },
                                [
                                  _c(
                                    "label",
                                    {
                                      staticClass: "form-label",
                                      attrs: {
                                        for: "NbAncragesDonnantSurTerrainPrive"
                                      }
                                    },
                                    [_vm._v("un autre terrain privé")]
                                  ),
                                  _vm._v(" "),
                                  _c("number-input", {
                                    key: "NbAncragesDonnantSurTerrainPrive",
                                    attrs: {
                                      disabled:
                                        _vm.data
                                          .NbAncragesDonnantSurVoiePublique > 0,
                                      min: 0,
                                      required: ""
                                    },
                                    model: {
                                      value:
                                        _vm.data
                                          .NbAncragesDonnantSurTerrainPrive,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.data,
                                          "NbAncragesDonnantSurTerrainPrive",
                                          _vm._n($$v)
                                        )
                                      },
                                      expression:
                                        "data.NbAncragesDonnantSurTerrainPrive"
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _vm.data.TypeOuvrage ===
                              "LignesEtCoffretsDistribution"
                                ? _c(
                                    "div",
                                    { staticClass: "col-2" },
                                    [
                                      _c(
                                        "label",
                                        {
                                          staticClass: "form-label",
                                          attrs: {
                                            for:
                                              "NbAncragesDonnantSurVoiePublique"
                                          }
                                        },
                                        [_vm._v("voie publique")]
                                      ),
                                      _vm._v(" "),
                                      _c("number-input", {
                                        key: "NbAncragesDonnantSurVoiePublique",
                                        attrs: {
                                          disabled:
                                            _vm.data
                                              .NbAncragesDonnantSurParcelle +
                                              _vm.data
                                                .NbAncragesDonnantSurTerrainPrive >
                                            0,
                                          min: 0,
                                          required: ""
                                        },
                                        model: {
                                          value:
                                            _vm.data
                                              .NbAncragesDonnantSurVoiePublique,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.data,
                                              "NbAncragesDonnantSurVoiePublique",
                                              _vm._n($$v)
                                            )
                                          },
                                          expression:
                                            "data.NbAncragesDonnantSurVoiePublique"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                : _vm._e()
                            ])
                          ]
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.data.Souterrain
                        ? [
                            _c("h3", { staticClass: "offset-2" }, [
                              _vm._v("Souterrain")
                            ]),
                            _vm._v(" "),
                            _c("hr"),
                            _vm._v(" "),
                            _c("div", { staticClass: "form-group row" }, [
                              _c("div", { staticClass: "col-sm-2 label" }, [
                                _vm._v("Ligne à poser")
                              ]),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "col-10" },
                                [
                                  _c("radio-input", {
                                    key: "LigneAPoser.Oui",
                                    attrs: {
                                      name: "LigneAPoser",
                                      value: true,
                                      label: "Oui",
                                      required: ""
                                    },
                                    model: {
                                      value: _vm.data.LigneAPoser,
                                      callback: function($$v) {
                                        _vm.$set(_vm.data, "LigneAPoser", $$v)
                                      },
                                      expression: "data.LigneAPoser"
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("radio-input", {
                                    key: "LigneAPoser.Non",
                                    attrs: {
                                      name: "LigneAPoser",
                                      value: false,
                                      label: "Non",
                                      required: ""
                                    },
                                    model: {
                                      value: _vm.data.LigneAPoser,
                                      callback: function($$v) {
                                        _vm.$set(_vm.data, "LigneAPoser", $$v)
                                      },
                                      expression: "data.LigneAPoser"
                                    }
                                  })
                                ],
                                1
                              )
                            ]),
                            _vm._v(" "),
                            _vm.data.LigneAPoser === "true" ||
                            _vm.data.LigneAPoser === true
                              ? [
                                  _c("div", { staticClass: "form-group row" }, [
                                    _vm._m(6),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "col-2" },
                                      [
                                        _c("number-input", {
                                          directives: [
                                            {
                                              name: "focus",
                                              rawName: "v-focus"
                                            }
                                          ],
                                          key: "LargeurOccupee",
                                          attrs: {
                                            min: 0,
                                            step: 0.1,
                                            required: ""
                                          },
                                          model: {
                                            value: _vm.data.LargeurOccupee,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.data,
                                                "LargeurOccupee",
                                                _vm._n($$v)
                                              )
                                            },
                                            expression: "data.LargeurOccupee"
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _vm._m(7),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "col-2" },
                                      [
                                        _c("number-input", {
                                          key: "NbCanalisations",
                                          attrs: { min: 0, required: "" },
                                          model: {
                                            value: _vm.data.NbCanalisations,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.data,
                                                "NbCanalisations",
                                                _vm._n($$v)
                                              )
                                            },
                                            expression: "data.NbCanalisations"
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _vm._m(8),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "col-2" },
                                      [
                                        _c("number-input", {
                                          key: "LongueurTotaleOccupee",
                                          attrs: {
                                            min: 0,
                                            step: 0.1,
                                            required: ""
                                          },
                                          model: {
                                            value:
                                              _vm.data.LongueurTotaleOccupee,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.data,
                                                "LongueurTotaleOccupee",
                                                _vm._n($$v)
                                              )
                                            },
                                            expression:
                                              "data.LongueurTotaleOccupee"
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  ])
                                ]
                              : _vm._e(),
                            _vm._v(" "),
                            _c("div", { staticClass: "form-group row" }, [
                              _c("div", { staticClass: "col-sm-2 label" }, [
                                _vm._v("Encrastrement de coffrets")
                              ]),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "col-10" },
                                [
                                  _c("radio-input", {
                                    key: "EncastrementCoffrets.Oui",
                                    attrs: {
                                      name: "EncastrementCoffrets",
                                      value: true,
                                      label: "Oui",
                                      required: ""
                                    },
                                    model: {
                                      value: _vm.data.EncastrementCoffrets,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.data,
                                          "EncastrementCoffrets",
                                          $$v
                                        )
                                      },
                                      expression: "data.EncastrementCoffrets"
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("radio-input", {
                                    key: "EncastrementCoffrets.Non",
                                    attrs: {
                                      name: "EncastrementCoffrets",
                                      value: false,
                                      label: "Non",
                                      required: ""
                                    },
                                    model: {
                                      value: _vm.data.EncastrementCoffrets,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.data,
                                          "EncastrementCoffrets",
                                          $$v
                                        )
                                      },
                                      expression: "data.EncastrementCoffrets"
                                    }
                                  })
                                ],
                                1
                              )
                            ]),
                            _vm._v(" "),
                            _vm.data.EncastrementCoffrets === "true" ||
                            _vm.data.EncastrementCoffrets === true
                              ? [
                                  _c("div", { staticClass: "form-group row" }, [
                                    _vm._m(9),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "col-2" },
                                      [
                                        _c("number-input", {
                                          key: "Elec-NbCoffrets",
                                          attrs: { min: 0, required: "" },
                                          model: {
                                            value: _vm.data.NbCoffrets,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.data,
                                                "NbCoffrets",
                                                _vm._n($$v)
                                              )
                                            },
                                            expression: "data.NbCoffrets"
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _vm._m(10),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "col-2" },
                                      [
                                        _c("number-input", {
                                          key: "LongueurCablesEncastres",
                                          attrs: {
                                            min: 0,
                                            step: 0.1,
                                            required: ""
                                          },
                                          model: {
                                            value:
                                              _vm.data.LongueurCablesEncastres,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.data,
                                                "LongueurCablesEncastres",
                                                _vm._n($$v)
                                              )
                                            },
                                            expression:
                                              "data.LongueurCablesEncastres"
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  ])
                                ]
                              : _vm._e()
                          ]
                        : _vm._e()
                    ]
                  : _vm._e(),
                _vm._v(" "),
                _vm.data.TypeOuvrage === _vm.TypeOuvrage.PosteTransfo ||
                _vm.data.TypeOuvrage === _vm.TypeOuvrage.PosteTransfoEtLigne
                  ? [
                      _c("h3", { staticClass: "offset-2" }, [
                        _vm._v("Poste de transformation")
                      ]),
                      _vm._v(" "),
                      _c("hr"),
                      _vm._v(" "),
                      _vm.data.TypeOuvrage === _vm.TypeOuvrage.PosteTransfo
                        ? _c("div", { staticClass: "form-group row" }, [
                            _c("div", { staticClass: "col-sm-2 label" }, [
                              _vm._v("Type de poste")
                            ]),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "col-10" },
                              [
                                _c("radio-input", {
                                  key: "TypePoste.Terrain",
                                  attrs: {
                                    name: "TypePoste",
                                    value: "Terrain",
                                    default: "Default",
                                    label: "Terrain",
                                    required: ""
                                  },
                                  model: {
                                    value: _vm.data.TypePoste,
                                    callback: function($$v) {
                                      _vm.$set(_vm.data, "TypePoste", $$v)
                                    },
                                    expression: "data.TypePoste"
                                  }
                                }),
                                _vm._v(" "),
                                _c("radio-input", {
                                  key: "TypePoste.Local",
                                  attrs: {
                                    name: "TypePoste",
                                    value: "Local",
                                    default: "Default",
                                    label: "Local",
                                    required: ""
                                  },
                                  model: {
                                    value: _vm.data.TypePoste,
                                    callback: function($$v) {
                                      _vm.$set(_vm.data, "TypePoste", $$v)
                                    },
                                    expression: "data.TypePoste"
                                  }
                                })
                              ],
                              1
                            )
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _c("div", { staticClass: "form-group row" }, [
                        _vm._m(11),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "col-2" },
                          [
                            _c("number-input", {
                              key: "Surface",
                              attrs: { min: 0, step: 0.1, required: "" },
                              model: {
                                value: _vm.data.Surface,
                                callback: function($$v) {
                                  _vm.$set(_vm.data, "Surface", _vm._n($$v))
                                },
                                expression: "data.Surface"
                              }
                            })
                          ],
                          1
                        )
                      ])
                    ]
                  : _vm._e(),
                _vm._v(" "),
                _vm.data.TypeOuvrage === _vm.TypeOuvrage.RepriseBranchement
                  ? [
                      _c("h3", { staticClass: "offset-2" }, [
                        _vm._v("Reprise de branchement")
                      ]),
                      _vm._v(" "),
                      _c("hr"),
                      _vm._v(" "),
                      _c("div", { staticClass: "form-group row" }, [
                        _c("div", { staticClass: "col-sm-2 label" }, [
                          _vm._v("Branchement élec.")
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "col-10" },
                          [
                            _c("radio-input", {
                              key: "RepriseBranchementElectrique.Oui",
                              attrs: {
                                name: "RepriseBranchementElectrique",
                                value: true,
                                label: "Oui",
                                required: ""
                              },
                              model: {
                                value: _vm.data.RepriseBranchementElectrique,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.data,
                                    "RepriseBranchementElectrique",
                                    $$v
                                  )
                                },
                                expression: "data.RepriseBranchementElectrique"
                              }
                            }),
                            _vm._v(" "),
                            _c("radio-input", {
                              key: "RepriseBranchementElectrique.Non",
                              attrs: {
                                name: "RepriseBranchementElectrique",
                                value: false,
                                label: "Non",
                                required: ""
                              },
                              model: {
                                value: _vm.data.RepriseBranchementElectrique,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.data,
                                    "RepriseBranchementElectrique",
                                    $$v
                                  )
                                },
                                expression: "data.RepriseBranchementElectrique"
                              }
                            })
                          ],
                          1
                        )
                      ]),
                      _vm._v(" "),
                      _vm.data.RepriseBranchementElectrique
                        ? [
                            _c("div", { staticClass: "form-group row" }, [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "col-sm-2 label font-weight-normal"
                                },
                                [_vm._v("Action")]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "col-5" },
                                [
                                  _c("select-input", {
                                    key: "RepriseBranchementElectriqueAction",
                                    attrs: {
                                      options:
                                        _vm.optionsActionRepriseBranchementElec
                                    },
                                    model: {
                                      value:
                                        _vm.data
                                          .RepriseBranchementElectriqueAction,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.data,
                                          "RepriseBranchementElectriqueAction",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "data.RepriseBranchementElectriqueAction"
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "col-sm-2 label font-weight-normal"
                                },
                                [_vm._v("Tranchée en privé")]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "col-3" },
                                [
                                  _c("radio-input", {
                                    key:
                                      "RepriseBranchementElectriqueTrancheePrive.Oui",
                                    attrs: {
                                      name:
                                        "RepriseBranchementElectriqueTrancheePrive",
                                      value: true,
                                      label: "Oui",
                                      required: ""
                                    },
                                    model: {
                                      value:
                                        _vm.data
                                          .RepriseBranchementElectriqueTrancheePrive,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.data,
                                          "RepriseBranchementElectriqueTrancheePrive",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "data.RepriseBranchementElectriqueTrancheePrive"
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("radio-input", {
                                    key:
                                      "RepriseBranchementElectriqueTrancheePrive.Non",
                                    attrs: {
                                      name:
                                        "RepriseBranchementElectriqueTrancheePrive",
                                      value: false,
                                      label: "Non",
                                      required: ""
                                    },
                                    model: {
                                      value:
                                        _vm.data
                                          .RepriseBranchementElectriqueTrancheePrive,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.data,
                                          "RepriseBranchementElectriqueTrancheePrive",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "data.RepriseBranchementElectriqueTrancheePrive"
                                    }
                                  })
                                ],
                                1
                              )
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "form-group row" }, [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "col-sm-2 label font-weight-normal"
                                },
                                [_vm._v("Précisions")]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "col-10" },
                                [
                                  _c("multiline-text-input", {
                                    key:
                                      "RepriseBranchementElectriquePrecisions",
                                    model: {
                                      value:
                                        _vm.data
                                          .RepriseBranchementElectriquePrecisions,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.data,
                                          "RepriseBranchementElectriquePrecisions",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "data.RepriseBranchementElectriquePrecisions"
                                    }
                                  })
                                ],
                                1
                              )
                            ])
                          ]
                        : _vm._e(),
                      _vm._v(" "),
                      _c("div", { staticClass: "form-group row" }, [
                        _c("div", { staticClass: "col-sm-2 label" }, [
                          _vm._v("ICE")
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "col-10" },
                          [
                            _c("radio-input", {
                              key: "RepriseBranchementIce.Oui",
                              attrs: {
                                name: "RepriseBranchementIce",
                                value: true,
                                label: "Oui",
                                required: ""
                              },
                              model: {
                                value: _vm.data.RepriseBranchementIce,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.data,
                                    "RepriseBranchementIce",
                                    $$v
                                  )
                                },
                                expression: "data.RepriseBranchementIce"
                              }
                            }),
                            _vm._v(" "),
                            _c("radio-input", {
                              key: "RepriseBranchementIce.Non",
                              attrs: {
                                name: "RepriseBranchementIce",
                                value: false,
                                label: "Non",
                                required: ""
                              },
                              model: {
                                value: _vm.data.RepriseBranchementIce,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.data,
                                    "RepriseBranchementIce",
                                    $$v
                                  )
                                },
                                expression: "data.RepriseBranchementIce"
                              }
                            })
                          ],
                          1
                        )
                      ]),
                      _vm._v(" "),
                      _vm.data.RepriseBranchementIce
                        ? [
                            _c("div", { staticClass: "form-group row" }, [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "col-sm-2 label font-weight-normal"
                                },
                                [_vm._v("Action")]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "col-5" },
                                [
                                  _c("select-input", {
                                    key: "RepriseBranchementIceAction",
                                    attrs: {
                                      options:
                                        _vm.optionsActionRepriseBranchementIce
                                    },
                                    model: {
                                      value:
                                        _vm.data.RepriseBranchementIceAction,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.data,
                                          "RepriseBranchementIceAction",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "data.RepriseBranchementIceAction"
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "col-sm-2 label font-weight-normal"
                                },
                                [_vm._v("Tranchée en privé")]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "col-3" },
                                [
                                  _c("radio-input", {
                                    key:
                                      "RepriseBranchementIceTrancheePrive.Oui",
                                    attrs: {
                                      name:
                                        "RepriseBranchementIceTrancheePrive",
                                      value: true,
                                      label: "Oui",
                                      required: ""
                                    },
                                    model: {
                                      value:
                                        _vm.data
                                          .RepriseBranchementIceTrancheePrive,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.data,
                                          "RepriseBranchementIceTrancheePrive",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "data.RepriseBranchementIceTrancheePrive"
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("radio-input", {
                                    key:
                                      "RepriseBranchementIceTrancheePrive.Non",
                                    attrs: {
                                      name:
                                        "RepriseBranchementIceTrancheePrive",
                                      value: false,
                                      label: "Non",
                                      required: ""
                                    },
                                    model: {
                                      value:
                                        _vm.data
                                          .RepriseBranchementIceTrancheePrive,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.data,
                                          "RepriseBranchementIceTrancheePrive",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "data.RepriseBranchementIceTrancheePrive"
                                    }
                                  })
                                ],
                                1
                              )
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "form-group row" }, [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "col-sm-2 label font-weight-normal"
                                },
                                [_vm._v("Précisions")]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "col-10" },
                                [
                                  _c("multiline-text-input", {
                                    key: "RepriseBranchementIcePrecisions",
                                    model: {
                                      value:
                                        _vm.data
                                          .RepriseBranchementIcePrecisions,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.data,
                                          "RepriseBranchementIcePrecisions",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "data.RepriseBranchementIcePrecisions"
                                    }
                                  })
                                ],
                                1
                              )
                            ])
                          ]
                        : _vm._e(),
                      _vm._v(" "),
                      _c("div", { staticClass: "form-group row" }, [
                        _c("div", { staticClass: "col-sm-2 label" }, [
                          _vm._v("Photo")
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "col-10" },
                          [
                            _c("vue-image-upload-resize", {
                              ref: "photoUpload",
                              staticClass: "form-control",
                              attrs: { maxWidth: 512, autoRotate: true },
                              on: {
                                input: function($event) {
                                  _vm.data.PhotoDataUri = $event
                                },
                                onUpload: function($event) {
                                  _vm.processing = true
                                },
                                onComplete: function($event) {
                                  _vm.processing = false
                                }
                              }
                            })
                          ],
                          1
                        )
                      ])
                    ]
                  : _vm._e()
              ]
            : _vm._e(),
          _vm._v(" "),
          _vm.data.TypeReseau === _vm.TypeReseau.EclairagePublic
            ? [
                _c("div", { staticClass: "form-group row" }, [
                  _vm._m(12),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "col-2" },
                    [
                      _c("number-input", {
                        key: "Ep-NbCoffrets",
                        attrs: { min: 0, required: "" },
                        model: {
                          value: _vm.data.NbCoffrets,
                          callback: function($$v) {
                            _vm.$set(_vm.data, "NbCoffrets", _vm._n($$v))
                          },
                          expression: "data.NbCoffrets"
                        }
                      })
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "form-group row" }, [
                  _vm._m(13),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "col-2" },
                    [
                      _c("number-input", {
                        key: "NbLuminairesSurFacade",
                        attrs: { min: 0, required: "" },
                        model: {
                          value: _vm.data.NbLuminairesSurFacade,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.data,
                              "NbLuminairesSurFacade",
                              _vm._n($$v)
                            )
                          },
                          expression: "data.NbLuminairesSurFacade"
                        }
                      })
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "form-group row" }, [
                  _vm._m(14),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "col-2" },
                    [
                      _c("number-input", {
                        key: "NbMats",
                        attrs: { min: 0, required: "" },
                        model: {
                          value: _vm.data.NbMats,
                          callback: function($$v) {
                            _vm.$set(_vm.data, "NbMats", _vm._n($$v))
                          },
                          expression: "data.NbMats"
                        }
                      })
                    ],
                    1
                  )
                ])
              ]
            : _vm._e(),
          _vm._v(" "),
          _vm.data.TypeReseau === _vm.TypeReseau.InfraCommunicationElectronique
            ? [
                _c("div", { staticClass: "form-group row" }, [
                  _vm._m(15),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "col-2" },
                    [
                      _c("number-input", {
                        key: "Telecom-LargeurOccupee",
                        attrs: { min: 0, step: 0.1, required: "" },
                        model: {
                          value: _vm.data.LargeurOccupee,
                          callback: function($$v) {
                            _vm.$set(_vm.data, "LargeurOccupee", _vm._n($$v))
                          },
                          expression: "data.LargeurOccupee"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm._m(16),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "col-2" },
                    [
                      _c("number-input", {
                        key: "Telecom-NbCanalisations",
                        attrs: { min: 0, required: "" },
                        model: {
                          value: _vm.data.NbCanalisations,
                          callback: function($$v) {
                            _vm.$set(_vm.data, "NbCanalisations", _vm._n($$v))
                          },
                          expression: "data.NbCanalisations"
                        }
                      })
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "form-group row" }, [
                  _vm._m(17),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "col-2" },
                    [
                      _c("number-input", {
                        key: "Telecom-LongueurTotaleOccupee",
                        attrs: { min: 0, step: 0.1, required: "" },
                        model: {
                          value: _vm.data.LongueurTotaleOccupee,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.data,
                              "LongueurTotaleOccupee",
                              _vm._n($$v)
                            )
                          },
                          expression: "data.LongueurTotaleOccupee"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm._m(18),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "col-2" },
                    [
                      _c("number-input", {
                        key: "Telecom-NbChambresTirage",
                        attrs: { min: 0, required: "" },
                        model: {
                          value: _vm.data.NbChambresTirage,
                          callback: function($$v) {
                            _vm.$set(_vm.data, "NbChambresTirage", _vm._n($$v))
                          },
                          expression: "data.NbChambresTirage"
                        }
                      })
                    ],
                    1
                  )
                ])
              ]
            : _vm._e(),
          _vm._v(" "),
          _vm.data.TypeReseau && _vm.data.TypeReseau !== _vm.TypeReseau.Default
            ? [
                _c("h3", { staticClass: "offset-2 mt-2" }, [
                  _vm._v("Parcelle(s)")
                ]),
                _vm._v(" "),
                _c("hr"),
                _vm._v(" "),
                _c("div", { staticClass: "form-group row" }, [
                  _vm._m(19),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "col-6" },
                    [
                      _c("v-select", {
                        attrs: {
                          id: "Commune",
                          filterable: false,
                          options: _vm.communesOptions
                        },
                        on: { search: _vm.fetchCommunes },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "option",
                              fn: function(option) {
                                return [
                                  _c("small", { staticClass: "float-right" }, [
                                    _vm._v(_vm._s(option.Population) + " hab.")
                                  ]),
                                  _vm._v(" "),
                                  _c("strong", [
                                    _vm._v(" " + _vm._s(option.CodeInsee) + " ")
                                  ]),
                                  _vm._v(
                                    "\n                            " +
                                      _vm._s(option.Libelle) +
                                      "\n                        "
                                  )
                                ]
                              }
                            },
                            {
                              key: "selected-option",
                              fn: function(option) {
                                return [
                                  _c("strong", [
                                    _vm._v(" " + _vm._s(option.CodeInsee) + " ")
                                  ]),
                                  _vm._v(
                                    "\n                            " +
                                      _vm._s(option.Libelle) +
                                      "\n                        "
                                  )
                                ]
                              }
                            },
                            {
                              key: "no-options",
                              fn: function(ref) {
                                var search = ref.search
                                var searching = ref.searching
                                var loading = ref.loading
                                return [
                                  _vm._v(
                                    "\n                            Veuillez taper le nom de la commune\n                        "
                                  )
                                ]
                              }
                            }
                          ],
                          null,
                          false,
                          830491654
                        ),
                        model: {
                          value: _vm.data.Commune,
                          callback: function($$v) {
                            _vm.$set(_vm.data, "Commune", $$v)
                          },
                          expression: "data.Commune"
                        }
                      })
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _vm.data.Commune
                  ? [
                      _c("div", { staticClass: "form-group row" }, [
                        _c("div", { staticClass: "col-sm-2 label" }, [
                          _vm._v("Parcelle enclavée")
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "col-10" },
                          [
                            _c("radio-input", {
                              key: "Enclave.Oui",
                              attrs: {
                                name: "Enclave",
                                value: true,
                                label: "Oui",
                                required: ""
                              },
                              model: {
                                value: _vm.data.Enclave,
                                callback: function($$v) {
                                  _vm.$set(_vm.data, "Enclave", $$v)
                                },
                                expression: "data.Enclave"
                              }
                            }),
                            _vm._v(" "),
                            _c("radio-input", {
                              key: "Enclave.Non",
                              attrs: {
                                name: "Enclave",
                                value: false,
                                label: "Non",
                                required: ""
                              },
                              model: {
                                value: _vm.data.Enclave,
                                callback: function($$v) {
                                  _vm.$set(_vm.data, "Enclave", $$v)
                                },
                                expression: "data.Enclave"
                              }
                            })
                          ],
                          1
                        )
                      ]),
                      _vm._v(" "),
                      _vm.data.Enclave
                        ? _c("div", { staticClass: "form-group row" }, [
                            _vm._m(20),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "col-10" },
                              [
                                _c("Acteur", {
                                  model: {
                                    value: _vm.data.Beneficiaire,
                                    callback: function($$v) {
                                      _vm.$set(_vm.data, "Beneficiaire", $$v)
                                    },
                                    expression: "data.Beneficiaire"
                                  }
                                })
                              ],
                              1
                            )
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _c("div", { staticClass: "form-group row" }, [
                        _vm._m(21),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "col-10" },
                          [
                            _vm._l(_vm.data.Parcelles, function(parcelle, i) {
                              return _c(
                                "div",
                                [
                                  _c("Parcelle", {
                                    attrs: {
                                      commune: _vm.data.Commune,
                                      i: i,
                                      proprietaires: _vm.getProprietaires()
                                    },
                                    on: {
                                      remove: function($event) {
                                        return _vm.removeParcelle(i)
                                      },
                                      "remove-proprietaire":
                                        _vm.removeProprietaire
                                    },
                                    model: {
                                      value: _vm.data.Parcelles[i],
                                      callback: function($$v) {
                                        _vm.$set(_vm.data.Parcelles, i, $$v)
                                      },
                                      expression: "data.Parcelles[i]"
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("hr")
                                ],
                                1
                              )
                            }),
                            _vm._v(" "),
                            _c("div", { staticClass: "row" }, [
                              _c("div", { staticClass: "col-6" }, [
                                _c(
                                  "button",
                                  {
                                    staticClass: "btn btn-sm btn-success",
                                    attrs: {
                                      type: "button",
                                      title: "Ajouter une parcelle"
                                    },
                                    on: { click: _vm.appendParcelle }
                                  },
                                  [
                                    _c("i", { staticClass: "fa fa-plus" }),
                                    _vm._v(
                                      "\n                                    Nouvelle parcelle\n                                "
                                    )
                                  ]
                                )
                              ])
                            ])
                          ],
                          2
                        )
                      ])
                    ]
                  : _vm._e(),
                _vm._v(" "),
                _vm.data.Parcelles.length > 0
                  ? [
                      _c("h3", { staticClass: "offset-2 mt-2" }, [
                        _vm._v("Convention(s)")
                      ]),
                      _vm._v(" "),
                      _c("hr"),
                      _vm._v(" "),
                      _c("div", { staticClass: "row" }, [
                        _c("div", { staticClass: "offset-2 col-10" }, [
                          _c(
                            "button",
                            {
                              staticClass: "btn btn-secondary btn-sm",
                              attrs: { type: "button" },
                              on: { click: _vm.autoSelect }
                            },
                            [
                              _c("i", { staticClass: "fa fa-refresh" }),
                              _vm._v(
                                "\n                            Préparer les conventions\n                        "
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "row mt-2" }, [
                            _c(
                              "div",
                              { staticClass: "card-columns" },
                              _vm._l(_vm.data.GeneratedConventions, function(
                                g,
                                i
                              ) {
                                return _c("GeneratedConvention", {
                                  key: g.Identifier,
                                  attrs: {
                                    options: _vm.conventionsOptions,
                                    parcelles: _vm.data.Parcelles
                                  },
                                  model: {
                                    value: _vm.data.GeneratedConventions[i],
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.data.GeneratedConventions,
                                        i,
                                        $$v
                                      )
                                    },
                                    expression: "data.GeneratedConventions[i]"
                                  }
                                })
                              }),
                              1
                            )
                          ])
                        ])
                      ])
                    ]
                  : _vm._e()
              ]
            : _vm._e(),
          _vm._v(" "),
          _c("hr"),
          _vm._v(" "),
          _c("div", { staticClass: "form-group row" }, [
            _c("div", { staticClass: "offset-2 col-10" }, [
              _c(
                "button",
                {
                  staticClass: "btn btn-orezo",
                  attrs: { disabled: _vm.processing }
                },
                [
                  _c("i", { staticClass: "fa fa-save" }),
                  _vm._v("\n                    Enregistrer\n                ")
                ]
              ),
              _vm._v(" "),
              _vm.id > 0 && _vm.data.GeneratedConventions.length > 0
                ? _c(
                    "button",
                    {
                      staticClass: "btn btn-outline-orezo",
                      attrs: {
                        disabled: _vm.processing,
                        formaction: "/Affaires/GenerateConventionsServitude"
                      }
                    },
                    [
                      _c("i", { staticClass: "fa fa-file-pdf-o" }),
                      _vm._v(
                        "\n                    Générer les  " +
                          _vm._s(_vm.data.GeneratedConventions.length) +
                          " conventions\n                "
                      )
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.id == 0
                ? _c("em", [
                    _vm._v(
                      "\n                    Veuillez enregistrer pour générer\n                "
                    )
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.processing
                ? _c("em", [
                    _c("i", { staticClass: "fa fa-spinner fa-spin" }),
                    _vm._v(" Traitement en cours\n                ")
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.error
                ? _c("em", { staticClass: "alert alert-warning" }, [
                    _c("i", { staticClass: "fa fa-warning" }),
                    _vm._v(" Une erreur s'est produite\n                ")
                  ])
                : _vm._e()
            ])
          ])
        ],
        2
      )
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-sm-2 label" }, [
      _c("label", { attrs: { for: "LongueurLigne" } }, [
        _vm._v("Longueur de la ligne (m)")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-sm-2 label" }, [
      _c("label", { attrs: { for: "NbSupports" } }, [
        _vm._v("Nombre de supports")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-sm-2 label" }, [
      _c("label", { staticClass: "mb-0", attrs: { for: "NbSupports" } }, [
        _vm._v("Dimensions des massifs")
      ]),
      _vm._v(" "),
      _c("br"),
      _vm._v(" "),
      _c("small", [_vm._v("Repère : Longueur (cm) x Largeur (cm)")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "input-group-prepend" }, [
      _c(
        "span",
        {
          staticClass: "input-group-text",
          staticStyle: { "margin-left": "-1px" }
        },
        [_vm._v(":")]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "input-group-prepend" }, [
      _c(
        "span",
        {
          staticClass: "input-group-text",
          staticStyle: { "margin-left": "-1px" }
        },
        [_vm._v("x")]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-sm-2 label" }, [
      _c("label", [_vm._v("Nombre d'ancrages sur façade donnant sur …")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-sm-2 label" }, [
      _c("label", { attrs: { for: "LargeurOccupee" } }, [
        _vm._v("Largeur occupée (m)")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-sm-2 label" }, [
      _c("label", { attrs: { for: "NbCanalisations" } }, [
        _vm._v("Nombre de canalisations")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-sm-2 label" }, [
      _c("label", { attrs: { for: "LongueurTotaleOccupee" } }, [
        _vm._v("Longueur totale occupée (m)")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-sm-2 label" }, [
      _c("label", { attrs: { for: "Elec-NbCoffrets" } }, [
        _vm._v("Nombre de coffrets")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-sm-2 label" }, [
      _c("label", { attrs: { for: "LongueurCablesEncastres" } }, [
        _vm._v("Longueur de(s) câble(s) encastré(s)")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-sm-2 label" }, [
      _c("label", { attrs: { for: "Surface" } }, [_vm._v("Surface (m²)")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-sm-2 label" }, [
      _c("label", { attrs: { for: "Ep-NbCoffrets" } }, [
        _vm._v("Nombre de coffrets")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-sm-2 label" }, [
      _c("label", { attrs: { for: "NbLuminairesSurFacade" } }, [
        _vm._v("Nombre de luminaires posés sur façade")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-sm-2 label" }, [
      _c("label", { attrs: { for: "NbMats" } }, [_vm._v("Nombre de mâts")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-sm-2 label" }, [
      _c("label", { attrs: { for: "Telecom-LargeurOccupee" } }, [
        _vm._v("Largeur occupée (m)")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-sm-2 label" }, [
      _c("label", { attrs: { for: "Telecom-NbCanalisations" } }, [
        _vm._v("Nb de canalisations")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-sm-2 label" }, [
      _c("label", { attrs: { for: "Telecom-LongueurTotaleOccupee" } }, [
        _vm._v("Longueur totale occupée (m)")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-sm-2 label" }, [
      _c("label", { attrs: { for: "Telecom-NbChambresTirage" } }, [
        _vm._v("Nb de chambres de tirage")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-sm-2 label" }, [
      _c("label", { attrs: { for: "Commune" } }, [_vm._v("Commune")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-sm-2 label" }, [
      _c("label", [_vm._v("Bénéficiaire (enclave)")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-sm-2 label" }, [
      _c("label", [_vm._v("Parcelle(s)")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-c74b248a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c74b248a","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./_wwwsrc/js/ConventionServitude/Components/ConventionServitude.vue
// module id = 678
// module chunks = 0